"use client";
import { ReactNode } from "react";
import { Avatar, AvatarProps } from "@heroui/react";

export interface CustomAvatarProps extends AvatarProps {
  src?: string;
  alt?: string;
  fallback?: ReactNode;
}

export function CustomAvatar({
  className,
  size,
  src,
  alt,
  fallback,
  ...props
}: CustomAvatarProps) {
  const sizeClass = size === "sm" ? "h-5 w-5" : "";

  return (
    <Avatar {...props} className={`${sizeClass} ${className ?? ""}`.trim()}>
      {src ? <Avatar.Image alt={alt} src={src} /> : null}
      <Avatar.Fallback>{fallback ?? alt?.charAt(0) ?? "U"}</Avatar.Fallback>
    </Avatar>
  );
}

export type { AvatarProps as BaseAvatarProps };
